import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const GlowingBorder = ({ className, children }) => {
  return (
    <div className={`relative ${className}`}>
      {/* Animated glow effect */}
      <motion.div 
        className="absolute inset-0 rounded-xl"
        animate={{
          boxShadow: [
            '0 0 0 rgba(255, 204, 0, 0)',
            '0 0 8px rgba(255, 204, 0, 0.3)',
            '0 0 0 rgba(255, 204, 0, 0)'
          ]
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      
      {/* Content */}
      {children}
    </div>
  );
};

export default GlowingBorder;
